import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
    selector: 'frontend-downtime-notification',
    templateUrl: './downtime-notification.component.html',
    styleUrls: ['./downtime-notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DowntimeNotificationComponent {
  title = 'Notification';
  message = 'No new notifications';

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { userNotification },
    private bottomSheetRef: MatBottomSheetRef<DowntimeNotificationComponent>
  ) {
    if (this.data.userNotification) {
      this.title = this.data.userNotification.notification_title;
      this.message = this.data.userNotification.notification_message;
    }
  }

  dismiss() {
    this.bottomSheetRef.dismiss({ ...this.data.userNotification, read: true });
  }
}
